/**
 * @file Album custom print shipping selection.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import pluralize from 'pluralize';

import Alert from '../global/Alert';
import {
  getAlbumCustomPrintName,
  getAlbumCustomPrintsTotalShippingPrice,
} from '../../util/custom-prints';
import CustomControl from '../global/CustomControl';
import { formatPriceForDisplay } from '../../util/format-money';

const propTypes = {
  albumCustomPrints: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
    }),
  ),
  onShippingSelection: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const AlbumCustomPrintShippingSelection = ({
  albumCustomPrints,
  onShippingSelection,
  className,
}) => {
  const classes = classNames({
    [className]: !!className,
  });
  const [albumCustomPrint] = albumCustomPrints;
  const amount = albumCustomPrints.length;
  const albumCustomPrintName = getAlbumCustomPrintName(albumCustomPrint);
  const totalShippingPrice = getAlbumCustomPrintsTotalShippingPrice(
    albumCustomPrints,
  );

  return (
    <Alert type="gray" className={classes}>
      <p className="mb-1">
        Choose if you want your {pluralize(albumCustomPrintName, amount)}{' '}
        shipped to your address or picked up at the event.
      </p>

      <CustomControl
        id="shipping-disabled"
        type="radio"
        name="shipping"
        size="sm"
        label={`I’ll pick ${pluralize('it', amount)} up at the event.`}
        className="mb-1"
        onChange={() => onShippingSelection(false, albumCustomPrints)}
        checked={!albumCustomPrint.includeShipping}
      />
      <CustomControl
        id="shipping-enabled"
        type="radio"
        name="shipping"
        size="sm"
        label={`I want ${pluralize(
          'it',
          amount,
        )} shipped ($${formatPriceForDisplay(totalShippingPrice)}).`}
        onChange={() => onShippingSelection(true, albumCustomPrints)}
        checked={albumCustomPrint.includeShipping}
      />
    </Alert>
  );
};

AlbumCustomPrintShippingSelection.propTypes = propTypes;

export default AlbumCustomPrintShippingSelection;
